module.exports = __webpack_public_path__ + "files/3a9188d7ec1db23f2377924e0d7f9926.png";